import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { createIntl, createIntlCache, } from '@concur/intl-runtime';
import { IntlContext } from '../useIntl';
/**
 * React provider for intl formatting functions
 */
export default function IntlProvider(props) {
    var _a = props.messages, messages = _a === void 0 ? {} : _a, localeData = props.localeData, customFormatters = props.customFormatters;
    var cache = useMemo(function () { return createIntlCache(); }, []);
    var intl = React.useMemo(function () {
        return createIntl(__assign(__assign({}, localeData), { messages: messages }), cache, customFormatters);
    }, [cache, messages, localeData, customFormatters]);
    return React.createElement(IntlContext.Provider, { value: intl }, props.children);
}
